// Dependencies
import React, { Component } from 'react';

// Primereact controls
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Rating } from "primereact/rating";
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import TrainingService from '../../redux/services/training';

// Styling
import './training-questionnaire.scss';

// Utils
import { QUESTION_TYPE_MULTIPLE_OPTION, QUESTION_TYPE_RATING, QUESTION_TYPE_SINGLE_OPTION, QUESTION_TYPE_TEXT } from '../../common/constants';

class TrainingQuestionnairePage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();

        this.state = {
            accessToken: null,
            validAccessToken: false,
            questionnaire: null,
            answers: [],
            fillStartDate: null,
            formSubmitted: false
        };
    }

    componentDidMount() {
        let search = window.location.search;       
        let urlParams = new URLSearchParams(search);

        this.validateAccessToken(urlParams);
    }

    validateAccessToken(urlParams) {
        let accessToken = urlParams.get('q');
        
        if(accessToken !== null) {
            TrainingService.validateQuestionnaireAccessToken(accessToken)
            .then((response) => {
                this.setState({
                    validAccessToken: response.valid
                });

                if(response.valid === true) {

                    let answers = [];

                    for (let i = 0; i < response.questionnaire.questions.length; i++) {
                        answers.push({
                            questionId: response.questionnaire.questions[i].questionId,
                            mandatory: response.questionnaire.questions[i].mandatory,
                            answer: null,
                            valid: true
                        });
                    }

                    this.setState({
                        accessToken: accessToken,
                        questionnaire: response.questionnaire,
                        answers: answers,
                        fillStartDate: new Date()
                    });
                }
                else {
                    window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
                }
            })
            .catch(error => {
                window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
            });
        }
        else {
            window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
        }
    }

    getAnswerField(questionId) {
        for (let i = 0; i < this.state.answers.length; i++) {
            if(this.state.answers[i].questionId === questionId) {
                return this.state.answers[i].answer;
            }            
        }
        return null;
    }

    updateAnswerField(questionId, answer) {
        let answers = this.state.answers;

        for (let i = 0; i < answers.length; i++) {
            if(answers[i].questionId === questionId) {
                answers[i].answer = answer;
            }            
        }
        
        this.setState({
            answers: answers
        });
    }

    updateMultiAnswerField(questionId, answer, checked) {
        let answers = this.state.answers;

        for (let i = 0; i < answers.length; i++) {
            if(answers[i].questionId === questionId) {
                if(answers[i].answer === null) {
                    answers[i].answer = [answer]; 
                }
                else {
                    if(checked) {
                        answers[i].answer.push(answer); 
                    }
                    else {
                        let otherAnswers = [];

                        for (let j = 0; j < answers[i].answer.length; j++) {
                            if(answers[i].answer[j] !== answer) {
                                otherAnswers.push(answers[i].answer[j]); 
                            }                            
                        }

                        answers[i].answer = (otherAnswers.length > 0) ? otherAnswers : null;
                    }
                }
            }            
        }
        
        this.setState({
            answers: answers
        });
    }

    getMultiAnswerField(questionId, optionAnswer) {       
        for (let i = 0; i < this.state.answers.length; i++) {
            if(this.state.answers[i].questionId === questionId) { 

                if(this.state.answers[i].answer === null) return false;

                for (let j = 0; j < this.state.answers[i].answer.length; j++) {
                    if(this.state.answers[i].answer[j] === optionAnswer) {
                        return true;
                    }
                }     
            }       
        }
        return false;
    }

    getValidColor(questionId) {
        for (let i = 0; i < this.state.answers.length; i++) {
            if(this.state.answers[i].questionId === questionId) {
                if(this.state.answers[i].mandatory === false) return null;

                return this.state.answers[i].valid ? null : "red";
            }            
        }

        return null;
    }

    renderQuestionControl(question) {
        let control = null;

        if(question.questionType === QUESTION_TYPE_TEXT) {
            control = <InputText id={"question-" + question.questionId} 
                                 key={"question-" + question.questionId} 
                                 type="text" 
                                 value={this.getAnswerField(question.questionId)}
                                 onChange={(e) => this.updateAnswerField(question.questionId, e.target.value)}
                                 className="survey-question"/>
        }

        if(question.questionType === QUESTION_TYPE_SINGLE_OPTION) {
            control = <div className="survey-question">
                {
                    question.options.map((option) => {
                        return (
                            <div key={option.title} style={{marginBottom:"25px"}}>
                                <RadioButton inputId={option.title}       
                                             key={"question-" + question.questionId}                             
                                             checked={this.getAnswerField(question.questionId) === option.title} 
                                             onChange={e => this.updateAnswerField(question.questionId, option.title)}/>
                                <label htmlFor={option.title} className="ml-2">{option.title}</label>
                            </div>
                        );
                    })
                }
            </div>
        }

        if(question.questionType === QUESTION_TYPE_MULTIPLE_OPTION) {
            control = <div className="survey-question">
                {
                    question.options.map((option) => {
                        return (
                            <div key={option.title} style={{marginBottom:"25px"}}>
                                <Checkbox inputId={option.title} 
                                          key={"question-" + question.questionId} 
                                          checked={this.getMultiAnswerField(question.questionId, option.title)} 
                                          onChange={e => this.updateMultiAnswerField(question.questionId, option.title, e.checked)}/>
                                <label htmlFor={option.title} className="ml-2">{option.title}</label>
                            </div>
                        );
                    })
                }
            </div>
        }

        if(question.questionType === QUESTION_TYPE_RATING) {
            control = <Rating key={"question-" + question.questionId} 
                              value={this.getAnswerField(question.questionId)} 
                              onChange={(e) => this.updateAnswerField(question.questionId, e.target.value)}   
                              className="survey-question"
                              cancel={false} /> 
        }

        return control;
    }

    validateForm() {
        let answers = this.state.answers;
        let valid = true;

        for (let i = 0; i < answers.length; i++) {
            if(answers[i].mandatory) {
                answers[i].valid = (answers[i].answer !== null && answers[i].answer !== "");

                if(answers[i].valid === false) valid = false;
            }      
        }

        console.log(answers);
        

        this.setState({
            answers: answers
        });

        return valid;
    }

    submitForm() {
        if(this.validateForm()) {
            let answers = [];

            for (let i = 0; i < this.state.answers.length; i++) {
                answers.push({
                    questionId: this.state.answers[i].questionId,
                    answer: this.state.answers[i].answer !== null ? Array.isArray(this.state.answers[i].answer) ? this.state.answers[i].answer.join() : this.state.answers[i].answer.toString() : null
                });
            }

            TrainingService.submitQuestionnaireAnswers({
                accessToken: this.state.accessToken,
                fillStartDate: this.state.fillStartDate,
                FillEndDate: new Date(),
                answers: answers
            })
            .then((response) => {
                this.setState({
                    formSubmitted: true
                });
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("trainings.messages.error"), life: 1500 });
            });
        }      
    }

    render() {

        return (
                this.state.validAccessToken === true && this.state.questionnaire !== null ?
                    <>
                        <div className="grid survey-content">
                            <div className="col-1"></div>
                            <div className="col-10">
                                <div className="card t-align-left mgt-30" style={{background: "#004B8B"}}>
                                    <div className="col-12">
                                        <img width="188" height="65" src="https://portal-qa.ordemdosfisioterapeutas.pt/wp-content/uploads/2021/02/ordem-fisioterapeutas-logo-branco.png"  alt="" loading="lazy"/>											
                                    </div>
                                    <h2 className='survey-title'>{this.state.questionnaire.title}</h2>
                                    <p className='survey-subtitle'>{this.state.questionnaire.subTitle}</p>
                                </div>
                            </div>
                            <div className="col-1"></div>
                            <div className="col-1"></div>
                            <div className="col-10">
                                <div className="card t-align-left survey-content-card">
                                    {
                                        this.state.formSubmitted ?
                                            <div className="col-12 t-align-center mgt-20">
                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                <span style={{fontSize:'15px'}}>{this.props.t("trainings.messages.submit-questionnaire")}</span>                                          
                                            </div> 
                                            :
                                            <>
                                                <p className='mb-40'><span className='survey-fs-15-red'>*</span><span className='survey-mandatory-title'>{this.props.t("general.mandatory")}</span></p>
                                                {
                                                    this.state.questionnaire.questions.map((question) => { 
                                                        return <>
                                                            <p key={"p-question-" + question.questionId} className='survey-fs-15' style={{color:this.getValidColor(question.questionId)}}>{question.questionId}. {question.title} {question.mandatory ? <span className='survey-mandatory-flag'>*</span> : null }</p>
                                                            {   
                                                                question.subTitle !== null ?
                                                                    <p className='survey-question-subtitle'>{question.subTitle}</p>
                                                                    : null
                                                            }
                                                            {
                                                                this.renderQuestionControl(question)
                                                            }
                                                        </>;
                                                    })
                                                }
                                                <Button className="p-button-info mr-2 mb-2 survey-fs-15" onClick={(e) => this.submitForm() }><b>{this.props.t("general.submit")}</b></Button>
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="col-1"></div>
                        </div>
                        <Toast position='bottom-left' ref={this._toast} />
                    </>
                    
                : null
        );
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
    }
};

export default connect(undefined, mapDispatchToProps)(withTranslation(TrainingQuestionnairePage));